import Animated from "@/components/Animation/Animated";
import CentraImage from "@/components/CentraImage";
import type { getEnvironmentGalleryComponent } from "@/lib/api/formatting/rorosTweed/productPage";
import useDevice from "@/lib/hooks/useDevice";

import styles from "./imageGrid.module.scss";

type ImageGridProps =
  | undefined
  | (Partial<ReturnType<typeof getEnvironmentGalleryComponent>> & {
      media?: {
        callback: () => void;
      }[];
    });

const UI = (props: ImageGridProps) => {
  const { mobile } = useDevice();
  if (!props) {
    return <></>;
  }
  const media = props.media;
  const quote = props.quote;

  return (
    <>
      {media && media[0] && (
        <section className={styles.container}>
          <div className={styles.image1Wrapper} onClick={media[0].callback}>
            <figure className={styles.image1}>
              <div className={styles.imageDiv}>
                <Animated>
                  <CentraImage src={media[0].uri} alt={media[0].alt} />
                </Animated>
              </div>
            </figure>
          </div>
          {media[1] && (
            <div className={styles.image2Wrapper} onClick={media[1].callback}>
              <figure className={styles.image2}>
                <div className={styles.imageDiv}>
                  <Animated>
                    <CentraImage src={media[1].uri} alt={media[1].alt} />
                  </Animated>
                </div>
              </figure>
            </div>
          )}
          {media[2] && (
            <div className={styles.image3Wrapper} onClick={media[2].callback}>
              <figure className={styles.image3}>
                <div className={styles.imageDiv}>
                  <Animated>
                    <CentraImage src={media[2].uri} alt={media[2].alt} />
                  </Animated>
                </div>
              </figure>
            </div>
          )}
          {media[1] && (media[4] || !mobile) && (
            <div className={styles.image4Wrapper} onClick={media[3]?.callback}>
              <figure className={styles.image4}>
                {media[3] && (
                  <div className={styles.imageDiv}>
                    <Animated>
                      <CentraImage src={media[3].uri} alt={media[3].alt} />
                    </Animated>
                  </div>
                )}
              </figure>
            </div>
          )}
          {media[4] && (
            <div className={styles.image5Wrapper} onClick={media[4].callback}>
              <figure className={styles.image5}>
                {media[4] && (
                  <div className={styles.imageDiv}>
                    <Animated>
                      <CentraImage src={media[4].uri} alt={media[4].alt} />
                    </Animated>
                  </div>
                )}
              </figure>
            </div>
          )}
          {media[5] && (
            <div className={styles.image6Wrapper} onClick={media[5].callback}>
              <figure className={styles.image6}>
                {media[5] && (
                  <div className={styles.imageDiv}>
                    <Animated>
                      <CentraImage src={media[5].uri} alt={media[5].alt} />
                    </Animated>
                  </div>
                )}
              </figure>
            </div>
          )}
          {media[6] && (
            <div className={styles.image7Wrapper} onClick={media[6].callback}>
              <div className={styles.image7Container}>
                <figure className={styles.image7}>
                  {media[6] && (
                    <div className={styles.imageDiv}>
                      <Animated>
                        <CentraImage src={media[6].uri} alt={media[6].alt} />
                      </Animated>
                    </div>
                  )}
                </figure>
              </div>
            </div>
          )}
          {media[0] && quote?.quote && (
            <div className={styles.quoteContainer}>
              <div className={styles.animatedWrapper}>
                <Animated>
                  <div className={styles.quoteWrapper}>
                    <p className={styles.quote}>{`"${quote.quote}"`}</p>
                    {quote.byline && (
                      <p className={styles.byline}>{quote.byline}</p>
                    )}
                  </div>
                </Animated>
              </div>
            </div>
          )}
        </section>
      )}
    </>
  );
};

export default UI;
